/**
 * Investor-Portal App-Container (#1138 Tag 3) — Routes inkl. Admin-Sektion.
 */
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { InvestorAuthProvider, useInvestorAuth } from '../../context/InvestorAuthContext';
import InvestorLogin from './InvestorLogin';
import InvestorLayout from './InvestorLayout';
import InvestorDashboard from './InvestorDashboard';
import InvestorTabelle from './InvestorTabelle';
import InvestorGuv from './InvestorGuv';
import InvestorAufwendungen from './InvestorAufwendungen';
import InvestorAnnahmen from './InvestorAnnahmen';
import InvestorMappingEditor from './InvestorMappingEditor';
import InvestorPlanEditor from './InvestorPlanEditor';
import InvestorUsers from './InvestorUsers';
import InvestorAuditLog from './InvestorAuditLog';
import InvestorSegmentOutbound from './InvestorSegmentOutbound';
import InvestorSegmentLager from './InvestorSegmentLager';
import InvestorSegmentInbound from './InvestorSegmentInbound';
import InvestorSegmentCarrier from './InvestorSegmentCarrier';
import InvestorSegmentMaterial from './InvestorSegmentMaterial';
import InvestorSegmentEbitda from './InvestorSegmentEbitda';
import InvestorEbitdaAudit from './InvestorEbitdaAudit';
import InvestorAudit from './InvestorAudit';
import InvestorScenario from './InvestorScenario';
import InvestorCashflow from './InvestorCashflow';
import InvestorLiquiditaet from './InvestorLiquiditaet';
import InvestorReport from './InvestorReport';

function ProtectedShell({ children, adminOnly }) {
  const { user, loading } = useInvestorAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FC]">
        <div className="animate-spin h-6 w-6 border-2 border-[#338edc] border-t-transparent rounded-full" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/investor/login" replace state={{ from: location.pathname }} />;
  }
  if (adminOnly && user.role !== 'admin') {
    return <InvestorLayout><div className="bg-white border border-[#E5E7EB] rounded-xl p-8 text-center text-sm text-[#6B7280]">Diese Seite ist nur für Admins.</div></InvestorLayout>;
  }
  return <InvestorLayout>{children}</InvestorLayout>;
}

export default function InvestorApp() {
  return (
    <InvestorAuthProvider>
      <Routes>
        <Route path="/investor/login" element={<InvestorLogin />} />
        <Route path="/investor" element={<ProtectedShell><InvestorDashboard /></ProtectedShell>} />
        <Route path="/investor/guv" element={<ProtectedShell><InvestorGuv /></ProtectedShell>} />
        <Route path="/investor/aufwendungen" element={<ProtectedShell><InvestorAufwendungen /></ProtectedShell>} />
        <Route path="/investor/segmente/outbound" element={<ProtectedShell><InvestorSegmentOutbound /></ProtectedShell>} />
        <Route path="/investor/segmente/lager" element={<ProtectedShell><InvestorSegmentLager /></ProtectedShell>} />
        <Route path="/investor/segmente/inbound" element={<ProtectedShell><InvestorSegmentInbound /></ProtectedShell>} />
        <Route path="/investor/segmente/carrier" element={<ProtectedShell><InvestorSegmentCarrier /></ProtectedShell>} />
        <Route path="/investor/segmente/material" element={<ProtectedShell><InvestorSegmentMaterial /></ProtectedShell>} />
        <Route path="/investor/segmente/ebitda" element={<ProtectedShell><InvestorSegmentEbitda /></ProtectedShell>} />
        <Route path="/investor/ebitda-audit" element={<ProtectedShell><InvestorEbitdaAudit /></ProtectedShell>} />
        <Route path="/investor/bilanz" element={<ProtectedShell><InvestorTabelle bereich="bilanz" title="Bilanz" /></ProtectedShell>} />
        <Route path="/investor/cashflow" element={<ProtectedShell><InvestorCashflow /></ProtectedShell>} />
        {/* #1838 — muss VOR dem /investor/* Catch-all stehen, sonst leitet er auf das Dashboard um */}
        <Route path="/investor/liquiditaet" element={<ProtectedShell><InvestorLiquiditaet /></ProtectedShell>} />
        <Route path="/investor/annahmen" element={<ProtectedShell><InvestorAnnahmen /></ProtectedShell>} />
        <Route path="/investor/audit" element={<ProtectedShell><InvestorAudit /></ProtectedShell>} />
        <Route path="/investor/szenario" element={<ProtectedShell><InvestorScenario /></ProtectedShell>} />
        <Route path="/investor/report" element={<ProtectedShell adminOnly><InvestorReport /></ProtectedShell>} />
        <Route path="/investor/admin/mapping" element={<ProtectedShell adminOnly><InvestorMappingEditor /></ProtectedShell>} />
        <Route path="/investor/admin/plan-editor" element={<ProtectedShell adminOnly><InvestorPlanEditor /></ProtectedShell>} />
        <Route path="/investor/admin/users" element={<ProtectedShell adminOnly><InvestorUsers /></ProtectedShell>} />
        <Route path="/investor/admin/audit-log" element={<ProtectedShell adminOnly><InvestorAuditLog /></ProtectedShell>} />
        <Route path="/investor/*" element={<Navigate to="/investor" replace />} />
      </Routes>
    </InvestorAuthProvider>
  );
}
